import script from "./QuizDrawerRulesPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizDrawerRulesPanel.vue?vue&type=script&setup=true&lang=ts"

import "./QuizDrawerRulesPanel.vue?vue&type=style&index=0&id=39ff2686&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ff2686"]])

export default __exports__